<template>
    <footer :style="cssProps" class="menu-bottom">
        <div class="main-menu-bottom">
            <div v-show="user.planType.length" :class="['lentgh-collum', { 'active-border-menu': btn[0] }]">
                <a @click="activeBtn(0, '/fornecedor/home')">
                    <div :class="['icon-mobile', { 'menu-acitve': btn[0] }]">
                        <i class="fas fa-home"></i>
                    </div>
                    <div :class="['title-bottom-mobile', { 'menu-acitve': btn[0] }]">Home</div>
                </a>
            </div>
            <!-- <div :class="['lentgh-collum', { 'active-border-menu': btn[1] }]">
				<a @click="activeBtn(1)" href="#"
					><div :class="['icon-mobile', { 'menu-acitve': btn[1] }]">
						<i :class="['fas fa-filter', ,]"></i>
					</div>
					<div
						:class="[
							'title-bottom-mobile',
							{ 'menu-acitve': btn[1] },
						]"
					>
						Funil
					</div></a
				>
			</div> -->
            <div :class="['lentgh-collum', { 'active-border-menu': btn[2] }]">
                <a @click="activeBtn(2, '/painel-de-concorrencias')">
                    <div>
                        <div
                            onload="SVGInject(this)"
                            :class="['icon-mobile-dashboard', { 'menu-acitve': btn[2] }]"
                        ></div>
                        <!-- <img src="@/assets/images/dashboard.svg" /> -->
                    </div>
                    <div :class="['title-bottom-mobile', { 'menu-acitve': btn[2] }]">
                        Painel
                    </div></a
                >
            </div>
            <!-- <div>
			<a @click="activeBtn(3)" :class="['lentgh-collum',{ 'active-border-menu': btn[3] }]" href="#"
				><div class="icon-mobile">
					<img
						src="@/assets/images/multiple.svg"
						class="icon-mobile"
						height="16px"
					/>
				</div>
				<div class="icon-mobile">Leads Prediais</div></a
			>
		</div> -->
            <div :class="['lentgh-collum', { 'active-border-menu': btn[4] }]">
                <a @click="activeBtn(4, '/fornecedor/minhas-cotacoes')">
                    <div :class="['icon-mobile', { 'menu-acitve': btn[4] }]">
                        <i class="fas fa-th-list"></i>
                    </div>
                    <div :class="['title-bottom-mobile', { 'menu-acitve': btn[4] }]">Oportunidades</div>
                </a>
            </div>
            <div :class="['lentgh-collum', { 'active-border-menu': btn[5] }]">
                <a @click="activeBtn(5, '/fornecedor/contatos')"
                    ><div :class="['icon-mobile', { 'menu-acitve': btn[5] }]">
                        <i class="fas fa-chevron-circle-down"> </i>
                    </div>
                    <div :class="['title-bottom-mobile', { 'menu-acitve': btn[5] }]">Aquisições</div></a
                >
            </div>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'BottomBarMobile',
    data: () => ({
        btn: [false, false, false, false, false, false]
    }),
    props: { show: Boolean, canBuyQuotationCreditCard: Boolean },
    methods: {
        activeBtn(index = undefined, url = false) {
            this.btn = this.btn.map(() => {
                return false;
            });
            if (index != undefined) this.btn[index] = true;
            if (url && url != this.$route.path) this.$router.push(url);
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['supplierData']),
        cssProps() {
            return {
                '--z-index': this.show ? 0 : 1
            };
        },
        showNewEngelinkMarketing() {
            return this.user.type.hasSubscription && this.supplierData.engelinkMarketingVisualized;
        },
        newTagPosition() {
            return {
                position: 'absolute',
                'z-index': '1',
                'font-size': '4px',
                'margin-top': '-40px',
                'margin-left': '20px'
            };
        }
    },
    watch: {
        '$route.name': {
            handler: function(name) {
                switch (name) {
                case 'DashboardSupplier':
                    return this.activeBtn(0);
                case 'CompetitionDashboard':
                    return this.activeBtn(2);
                case 'MyOpportunities':
                    return this.activeBtn(4);
                case 'MyContacts':
                    return this.activeBtn(5);
                }
                this.activeBtn();
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        switch (this.$route.name) {
        case 'DashboardSupplier':
            return this.activeBtn(0);
        case 'CompetitionDashboard':
            return this.activeBtn(2);
        case 'MyOpportunities':
            return this.activeBtn(4);
        case 'MyContacts':
            return this.activeBtn(5);
        }
        this.activeBtn();
    }
};
</script>

<style>
.menu-bottom {
    border: 2px solid #efefef;
    position: fixed;
    z-index: var(--z-index);
    bottom: 0;
    background-color: #fff;
    width: 100%;
    height: 55px;
}
.main-menu-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 7px;
}
.lentgh-collum {
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.icon-mobile {
    display: flex;
    color: #b5b5b5;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.icon-mobile-dashboard {
    height: 25px;
    width: 25px;
    background-color: #b5b5b5;
    -webkit-mask: url('~@/assets/images/dashboard.svg') no-repeat 50% 50%;
    mask: url('~@/assets/images/dashboard.svg') no-repeat 50% 50%;
}
.title-bottom-mobile {
    font-size: 10px;
    color: #b5b5b5;
}
.icon-mobile-dashboard.menu-acitve {
    background-color: #007bff;
}
.menu-acitve {
    color: #007bff;
}
div .active-border-menu {
    margin-top: -10px;
    right: 50px;
    color: #007bff;
    padding-top: 8px;
    border-top: 2px solid #007bff;
    /* transition: all 0.5s ease 0s; */
}
</style>
